import { useState } from "react";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import sideArrow from "../../images/icons/sideArrow.png";
import { Fade } from "react-awesome-reveal";
const testimonials = [
  {
    id: 1,
    name: "Rahul Mehta",
    role: "Travel Operations Lead, Tech Solutions Inc.",
    text: "Carzen Logistics has transformed our employee travel experience — punctual, professional and always on point",
    image1: "https://randomuser.me/api/portraits/men/75.jpg",
    // image2: "https://randomuser.me/api/portraits/women/65.jpg",
    bgColor: "bg-[#C89B5E]",
  },
  {
    id: 2,
    name: " Priya Nair",
    role: "HR Manager, HR Manager, Innovatech Global.",
    text: "When you have clients flying in often, you need a partner you can rely on. Carzen handled everything from airport pick-ups to multi-city transfers with ease.",
    image1: "https://randomuser.me/api/portraits/women/45.jpg",
    // image2: "https://randomuser.me/api/portraits/men/32.jpg",
    bgColor: "bg-[#B88A5A]",
  },
  {
    id: 3,
    name: " Amit Sharma",
    role: "Procurement Head, SoftWare Developers Ltd",
    text: "Our monthly rental plan with Carzen gave us predictable costs, one invoice and zero headaches. The fleet and drivers are top quality.",
    image1: "https://randomuser.me/api/portraits/men/51.jpg",
    // image2: "https://randomuser.me/api/portraits/women/34.jpg",
    bgColor: "bg-[#D0A46E]",
  },
  {
    id: 3,
    name: " Sneha Kapoor",
    role: "Event Manager, GreenTech Enterprises",
    text: "For our team retreats and tours, Carzen’s minivan & SUV options worked perfectly. The service was seamless from start to finish.",
    image1: "https://randomuser.me/api/portraits/men/51.jpg",
    image2: "https://randomuser.me/api/portraits/women/34.jpg",
    bgColor: "bg-[#D0A46E]",
  },
];

export default function Testimon() {
  const [current, setCurrent] = useState(0);

  const handleNext = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setCurrent(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  const { name, role, text, image1, bgColor } = testimonials[current];

  return (
    <section
      className="
        
               bg-gradient-to-t from-[#CCA065]/10 to-transparent  max-w-8xl   md:px-[50px] lg:px-[120px] py-16 md:py-20    text-center"
    >
      {/* Header */}

      <Fade direction="left" triggerOnce ascade damping={0.2}>
        <div className="max-w-6xl mx-auto mb-12">
          <h4 className="text-sm md:h-[26px] mb-2 md:mb-0 md:text-[16px] text-gray-500  tracking-wide">
            What Our Clients Say
          </h4>
          <h2 className="mb-6 text-2xl  md:text-4xl md:h-[62px] text-center content-center font-bold text-gray-900">
            Trusted by Leading IT & Corporate Teams
          </h2>
          <p className="text-gray-500 text-[14px] md:text-[18px] font-medium mt-2 md:mt-6">
            See why businesses choose Carzen Logistics for seamless and reliable
            travel solutions.
          </p>
        </div>

        {/* Testimonial Card */}
        <div
          className={`${bgColor} text-black bg-transparent rounded-xl shadow-md p-8 md:p-10 max-w-4xl mx-auto transition-all duration-500 ease-in-out`}
        >
          <div className="flex justify-start items-center mb-12 space-x-2">
            <img
              src={image1}
              alt="client"
              className="w-10 h-10 rounded-full object-cover border-2 border-white"
            />
            {/* <img
            src={image2}
            alt="client"
            className="w-10 h-10 rounded-full object-cover border-2 border-white"
          /> */}
          </div>
          <p className="text-lg md:text-[22px] text-start leading-relaxed italic mb-12">
            “{text}”
          </p>
          <div className="text-left">
            <p className=" md:text-[18px]">{name}</p>
            <p className="text-sm font-semibold md:text-[16px]">{role}</p>
          </div>
        </div>

        {/* Navigation Arrows */}
        <div className="max-w-4xl flex justify-end items-end mt-4 md:mt-4 gap-4 mx-auto">
          <button
            onClick={handlePrev}
            className="p-2 rounded-full bg-gray-100 hover:bg-gray-300 text-gray-800 transition"
          >
            <img
              src={sideArrow}
              className="w-4 h-4 md:w-[10px] md:h-[17px]"
              alt="left side arrow"
            />
            {/* <FaChevronLeft /> */}
          </button>
          <button
            onClick={handleNext}
            className="p-2 rounded-full bg-gray-100 hover:bg-gray-300 text-gray-800 transition"
          >
            <img
              src={sideArrow}
              className="w-4 h-4 md:w-[10px] md:h-[17px] rotate-180 "
              alt="right side arrow"
            />

            {/* <FaChevronRight /> */}
          </button>
        </div>
      </Fade>
    </section>
  );
}
